export const config = {
  rowSelection: false,
  columns: [
    {
      title: "ID",
      dataIndex: "id",
      width: 210
    },
    {
      title: "公司",
      dataIndex: "shopName",
      width: 120
    },
    {
      title: "限量",
      dataIndex: "limitValue",
      width: 130,
      editable: true
    },
    {
      title: "操作",
      width: 150,
      fixed: "right",
      render: "editCell"
    }
  ],
  search: [],
  footer: [
    {
      label: "添加",
      type: "primary",
      events: ["onClick:onAdd"]
    }
  ]
}
